<h2 mat-dialog-title>
  Sélectionner un local standard (provenant de la bibliothèque).
</h2>
<app-list-lib-room
  [actions]="['select', 'search']"
  (select)="close($event)">
</app-list-lib-room>
